import { default as CrmCompanyList } from './list';
import { default as CrmCompanyCreate } from './create';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: CrmCompanyList,
    create: CrmCompanyCreate,
};